import * as Sentry from "@sentry/react";

/**
 * Reports a handled public-Jan failure to Sentry.
 *
 * The chat machine catches its failures and turns them into error *state*
 * (`dispatch({ type: "error" })`), so they never bubble up as uncaught
 * exceptions and Sentry's global handlers never see them. Without this, the
 * failure modes most specific to the demo — session start, streaming, the
 * email gate, stale-session recovery — are invisible in production.
 *
 * Tagged `surface: public-jan` plus the failing `operation` so they're
 * filterable in the shared Sentry project. Never throws: error reporting must
 * not be able to break the demo it's observing.
 */
export const reportPublicJanError = (
  operation: string,
  error: unknown
): void => {
  try {
    Sentry.captureException(
      error instanceof Error ? error : new Error(String(error)),
      { tags: { surface: "public-jan", operation } }
    );
  } catch {
    // Reporting must never surface to the user.
  }
};
